module.exports = __webpack_public_path__ + "img/hover-left.ed368970.svg";